module.exports = __webpack_public_path__ + "img/logo.5b7fd182.svg";